import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum DenimTearsPOLineItemKeys {
  goodOrService = 'goodOrService', // Good or Service description
  product = 'product', // Product name
  sku = 'sku', // SKU or item code
  styleNumber = 'styleNumber',
  size = 'size',
  color = 'color',
  price = 'price', // Price per unit
  qty = 'qty', // Quantity
  amount = 'amount', // Total amount (price * qty)
}

export const denimTearsPurchaseOrderFileDataSchema = yup.object().shape({
  buyer: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  purchaseOrderNumber: yup.string().nullable().optional(),
  dateIssued: yup.string().nullable().optional(),
  vendorName: yup.string().nullable().optional(),
  billTo: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    contactName: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  deliverTo: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    contactName: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  items: yup
    .array()
    .of(
      yup.object().shape({
        goodOrService: yup.string().nullable().optional(),
        product: yup.string().nullable().optional(),
        sku: yup.string().nullable().optional(),
        styleNumber: yup.string().nullable().optional(),
        size: yup.string().nullable().optional(),
        color: yup.string().nullable().optional(),
        price: yup.string().nullable().optional(),
        qty: yup.string().nullable().optional(),
        amount: yup.string().nullable().optional(),
      }),
    )
    .required(),
  taxRate: yup.string().nullable().optional(),
  notes: yup.string().nullable().optional(),
})

export type DenimTearsPurchaseOrderFileData = yup.InferType<
  typeof denimTearsPurchaseOrderFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<DenimTearsPurchaseOrderFileData>

export const denimTearsPurchaseOrderFileMappings: RequiredFileData = {
  buyer: {
    companyName: '75db5450-fa0a-4084-9e90-3a77db8d39ac',
    emailAddress: 'ce1c1e01-1dd1-45e6-913d-bb262babe362',
  },
  purchaseOrderNumber: 'b9e96b69-8eed-439d-969b-dbeba2f22f35',
  dateIssued: '03e9ccb2-e407-4254-bca9-7a228f4c0a4b',
  vendorName: '42f6f06e-d88b-4d4f-8d08-187591d40bd5',
  billTo: {
    companyName: '76c3be46-dce1-4f92-bbc6-8df474b48b64',
    address: '4c6455e2-915c-4d4e-b4f5-8a6d6f85fefe',
    contactName: 'a49a4310-85a1-44ee-aca8-1236b048f67b',
    phoneNumber: '4faa5b91-b939-4b08-9c68-0c780b2e34fe',
    emailAddress: '1498988d-3e54-464f-a99c-0d941f893835',
  },
  deliverTo: {
    companyName: 'bf0879d9-6f12-4b20-b87d-b40d817feffe',
    address: 'c9be56dd-7cda-4aec-804c-8e9aa4e5fe2f',
    contactName: '015e4aa0-7ce3-432c-bfa1-9e8a4b9a9816',
    phoneNumber: '3d05ea5e-bffa-416b-8287-226535ba012b',
    emailAddress: 'd84c7114-af49-4de0-aa31-b057cc348c57',
  },
  items: [
    {
      goodOrService: '2311acdd-97be-498a-838d-6ca902f31425',
      product: 'cf5116b8-5031-44f1-b59f-5a5eb61ca3c2',
      sku: 'a4434720-71a0-47d8-b2d7-d56aa32d1c2f',
      styleNumber: '90470477-31e8-4ddf-b614-6adc44ec9706',
      size: '98b95777-2690-4e13-933d-bffe9c34eb3b',
      color: 'bdab82e2-e11f-486f-a6ab-27b9ef2131bd',
      price: '5d82683b-b57f-4d16-86a9-dfd3904cf3ac',
      qty: 'cbc64042-112e-48e8-a959-3d5fb9ba9176',
      amount: null,
    },
  ],
  taxRate: '8e7c534c-5d5c-446a-a599-01a9d6dc4ac5',
  notes: '613685c9-2971-498e-b8e4-b18ff89b96c6',
}
